// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_hc-0";
export var actionModalContentContainer = "_hc-1";
export var createTagButton = "_hc-2";
export var footerContainer = "_hc-7";
export var fullWidthDivider = "_hc-3";
export var hasCreateTagButton = "_hc-4";
export var noCreateTagButton = "_hc-5";
export var tagsContainer = "_hc-6";
export var tagsModalContentContainer = "_hc-8";